const CHUNK_RELOAD_KEY = '__rmk_chunk_reload__';
const CHUNK_RELOAD_COOLDOWN_MS = 10000;

/**
 * Определяет, что ошибка вызвана недоступным JS-чанком (устаревший деплой:
 * старый HTML тянет чанк с хэшем, которого больше нет на сервере).
 */
export function isChunkLoadError(error?: {
  name?: string;
  message?: string;
}): boolean {
  if (!error) return false;
  const name = error.name || '';
  const message = error.message || '';
  return (
    name === 'ChunkLoadError' ||
    /Loading chunk [\w-]+ failed/i.test(message) ||
    /Loading chunk failed after/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message)
  );
}

/**
 * Одноразовая перезагрузка страницы за свежим HTML при ChunkLoadError.
 * Кулдаун в sessionStorage защищает от бесконечной петли перезагрузок,
 * если чанк недоступен даже после обновления.
 * @returns true, если перезагрузка инициирована (логировать ошибку не нужно).
 */
export function reloadOnceForChunkError(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const now = Date.now();
    const last = Number(window.sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
    if (now - last > CHUNK_RELOAD_COOLDOWN_MS) {
      window.sessionStorage.setItem(CHUNK_RELOAD_KEY, String(now));
      window.location.reload();
      return true;
    }
  } catch {}
  return false;
}
